import { toast } from 'react-toastify';
import io from 'socket.io-client';

let socket = null;

export const initializeSocket = (token) => {
  if (!socket) {
    socket = io(process.env.REACT_APP_SOCKET_BASE_URL || 'http://localhost:4000', {
      query: { token },
      transports: ['websocket']
    });

    socket.on('live_class_started', (data) => {
      toast.success(`Live Class Started: ${data.title}`, {
        position: "top-right",
        autoClose: 5000,
        hideProgressBar: false,
        closeOnClick: true,
        pauseOnHover: true,
        draggable: true,
      });
      
      setTimeout(() => {
        window.location.reload();
      }, 2000);
    });

    socket.on('connect', () => {
      // console.log('Socket connected for live class notifications');
      const userId = JSON.parse(localStorage.getItem('user'))?.id;
      if (userId) {
        socket.emit('joinRoom', userId);
      }
    });

    socket.on('disconnect', () => {
      // console.log('Socket disconnected');
    });
  }
  
  return socket;
};

export const disconnectSocket = () => {
  if (socket) {
    socket.disconnect();
    socket = null;
  }
};

export const getSocket = () => socket;